import {tv} from 'tailwind-variants'

export const cinematicHeroVariants = tv({
  slots: {
    container: 'group relative grid h-fit w-full',
    gridSlot:
      'z-[3] col-start-1 col-end-auto row-start-1 row-end-auto mx-auto pt-navbar-height',
    headingContainer: 'lg:col-span-8 lg:col-start-5',
    heading: 'z-[1] text-text-default arcadia-display-6',
    disclaimerSlot: '',
  },
  variants: {
    alignment: {
      center: {
        headingContainer: 'col-span-full lg:col-start-5',
      },
      left: {
        headingContainer: 'col-span-full sm:col-span-8 lg:col-start-1',
      },
    },
    variant: {
      overlay: {
        gridSlot: 'h-full max-h-dvh place-items-center pb-navbar-height',
        disclaimerSlot: 'row-start-2 pt-s5 sm:row-start-1 sm:pt-0',
      },
      stacked: {
        gridContainer: 'var(--background)',
        disclaimerSlot: 'row-start-2',
        headingContainer: 'pb-s8',
      },
      // TODO: Remove when all old cinematic heros are updated
      old: {},
    },
  },
})
